<template lang="pug">
.hero(ref='hero')
  .row
    .col-4.col-sm-2
    .col-4.col-sm-2
      img.main-img.img-fluid(:alt='imgAlt')
    .col-4.col-sm-8
    .col-1
    .col-10.col-sm-4
      .row.mt-3.animated.slideInDown
        .col-12.d-flex.justify-content-center.align-items-center
          oc-play-button(:videoUrl='playVideoUrl')
          h3.ml-3.d-inline-block {{ title }}
        .col-12.mt-4.mt-sm-3.d-flex.justify-content-center
          h4.font-weight-light {{ subtitle }}
            .col-1.col-sm-7
    oc-arrow(:urlRef='nextSection')
</template>

<script>
import OcPlayButton from '@/components/shared/PlayButton.vue'
import OcArrow from '@/components/shared/Arrow.vue'

export default {
    components: { OcPlayButton, OcArrow },
    data () {
        return {
            imgAlt: 'Ortografía Cerebral',
            title: 'Dra. Mirna Juraidini',
            subtitle: 'Traductora de tu inconsciente...',
            playVideoUrl: 'https://www.youtube.com/embed/dqwTEIbsTHs',
            nextSection: '#oc'
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/landing/Hero.vue